export default "__VITE_ASSET__BAVPQFQq__"